import { render, staticRenderFns } from "./ScreenConfigureGroups.vue?vue&type=template&id=1d813188&scoped=true"
import script from "./ScreenConfigureGroups.vue?vue&type=script&lang=js"
export * from "./ScreenConfigureGroups.vue?vue&type=script&lang=js"
import style0 from "./ScreenConfigureGroups.vue?vue&type=style&index=0&id=1d813188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d813188",
  null
  
)

export default component.exports